import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const LearnerAuthContext = createContext(null);

export function LearnerAuthProvider({ children }) {
  const [learner, setLearner] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const checkAuth = async () => {
      try {
        const { data } = await axios.get(`${API}/learner/me`, { withCredentials: true });
        if (!cancelled) setLearner(data);
      } catch {
        if (!cancelled) setLearner(false);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    checkAuth();
    return () => { cancelled = true; };
  }, []);

  const login = async (email) => {
    const { data } = await axios.post(
      `${API}/learner/login`,
      { email },
      { withCredentials: true }
    );
    setLearner(data);
    setLoading(false);
    return data;
  };

  const logout = async () => {
    try {
      await axios.post(`${API}/learner/logout`, {}, { withCredentials: true });
    } finally {
      setLearner(false);
    }
  };

  return (
    <LearnerAuthContext.Provider value={{ learner, loading, login, logout }}>
      {children}
    </LearnerAuthContext.Provider>
  );
}

export function useLearnerAuth() {
  const context = useContext(LearnerAuthContext);
  if (!context) throw new Error("useLearnerAuth must be used within LearnerAuthProvider");
  return context;
}
